/*
 * Predictive search (Dope) — live dropdown on Shopify's /search/suggest.json.
 * Shows grouped results: Products, Collections, Blog posts, Pages.
 * Self-initializes every [data-tda-ps] on the page. Namespaced so it never
 * touches Turbo's built-in header autocomplete.
 */
(function () {
  'use strict';

  var SUGGEST = '/search/suggest.json';
  var DEBOUNCE_MS = 225;
  var DEFAULT_MIN = 2;
  // suggest.json's resources[limit] is a TOTAL cap across all requested types
  // (products get squeezed when other types are present), so we fetch products
  // in their own call to guarantee up to 10, and the taxonomy separately.
  var MAX_PRODUCTS = 10;
  var MAX_COLLECTIONS = 3;
  var MAX_SUGGESTIONS = 5; // popular search-term suggestions
  var MAX_EDITORIAL = 2; // blog posts + pages combined
  // Group labels/order for rendering.
  var GROUPS = [
    { key: 'collections', label: 'Collections' },
    { key: 'products',    label: 'Products' },
    { key: 'pages',       label: 'Pages' },
    { key: 'suggestions', label: 'Popular Suggestions' },
    { key: 'articles',    label: 'Blog posts' }
  ];

  // suggest.json returns price as a DOLLAR-format string (e.g. "89.00").
  // Do NOT divide by 100. Dividing showed $0.89 instead of $89 on the sibling store.
  function money(price) {
    if (price === null || price === undefined) return '';
    var n = parseFloat(String(price).replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2);
  }

  function withWidth(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function imgOf(o) {
    if (!o) return '';
    if (o.featured_image && o.featured_image.url) return o.featured_image.url;
    if (typeof o.image === 'string') return o.image;
    if (o.image && o.image.url) return o.image.url;
    return '';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // --- GA4 search/filter tracking (additive; gtag with dataLayer fallback) ---
  function tdaTrack(name, params) {
    try {
      if (typeof window.gtag === 'function') { window.gtag('event', name, params || {}); }
      else { window.dataLayer = window.dataLayer || []; var p = {}; var s = params || {}; for (var k in s) p[k] = s[k]; p.event = name; window.dataLayer.push(p); }
    } catch (e) {}
  }
  // Passive, site-wide: capture filter clicks on the search-results filter
  // (.tda-sfb-opt) and the collection filter (.tda-fb-opt link). Read-only.
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var so = t.closest('.tda-sfb-opt');
    if (so) {
      var dd = so.closest('.tda-sfb-dd');
      tdaTrack('filter_select', {
        filter_group: (dd && dd.getAttribute('data-grp')) || '',
        filter_value: so.getAttribute('data-val') || (so.textContent || '').trim(),
        filter_source: 'search'
      });
      return;
    }
    var co = t.closest('.tda-fb-opt');
    if (co) {
      var cdd = co.closest('.tda-fb-dd');
      var btn = cdd && cdd.querySelector('.tda-fb-btn');
      var link = co.querySelector('a');
      tdaTrack('filter_select', {
        filter_group: btn ? (btn.textContent || '').replace(/\s+/g, ' ').trim() : '',
        filter_value: (link ? link.textContent : co.textContent || '').replace(/\s+/g, ' ').trim(),
        filter_source: 'collection'
      });
      return;
    }
  }, true);

  function init(root) {
    if (root.__tdaPsInit) return;
    root.__tdaPsInit = true;

    var input = root.querySelector('[data-tda-ps-input]');
    var panel = root.querySelector('[data-tda-ps-panel]');
    var list = root.querySelector('[data-tda-ps-results]');
    var state = root.querySelector('[data-tda-ps-state]');
    var allLink = root.querySelector('[data-tda-ps-all]');
    var clearBtn = root.querySelector('[data-tda-ps-clear]');
    if (!input || !panel || !list) return;

    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var minChars = parseInt(root.getAttribute('data-min'), 10) || DEFAULT_MIN;

    var timer = null;
    var controller = null;
    var items = [];   // flat, navigable: {group,groupLabel,title,url,image,price}
    var optEls = [];  // <li> elements parallel to items
    var activeIndex = -1;
    var lastQuery = '';

    function open() {
      if (panel.hidden) panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    }
    function isOpen() { return !panel.hidden; }

    function showState(msg) {
      list.innerHTML = '';
      optEls = [];
      state.textContent = msg;
      state.hidden = false;
      allLink.hidden = true;
    }

    function fullHref(q) {
      return searchUrl + '?q=' + encodeURIComponent(q) + '&type=product,article,page';
    }

    function setActive(i) {
      if (activeIndex >= 0 && optEls[activeIndex]) optEls[activeIndex].classList.remove('is-active');
      activeIndex = i;
      if (i >= 0 && optEls[i]) {
        optEls[i].classList.add('is-active');
        input.setAttribute('aria-activedescendant', optEls[i].id);
        if (optEls[i].scrollIntoView) optEls[i].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function groupHeader(label) {
      var h = document.createElement('div');
      h.className = 'tda-ps__group';
      h.setAttribute('role', 'presentation');
      h.textContent = label;
      return h;
    }

    function makeOpt(p, i, compact) {
      var el = document.createElement('div');
      var isSugg = p.group === 'suggestions';
      el.className = 'tda-ps__opt' + (compact ? ' tda-ps__opt--compact' : '') + (p.image ? '' : ' tda-ps__opt--noimg') + (isSugg ? ' tda-ps__opt--sugg' : '');
      el.id = 'tda-ps-opt-' + i;
      el.setAttribute('role', 'option');
      var price = money(p.price);
      var dim = compact ? 34 : 46;
      var lead = isSugg
        ? '<span class="tda-ps__sugg-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg></span>'
        : (p.image
          ? '<img src="' + esc(withWidth(p.image, 96)) + '" alt="" width="' + dim + '" height="' + dim + '">'
          : '<span class="tda-ps__ph" aria-hidden="true"></span>');
      el.innerHTML =
        lead +
        '<span class="tda-ps__opt-main">' +
          '<span class="tda-ps__opt-title">' + esc(p.title) + '</span>' +
          (price ? '<span class="tda-ps__opt-price">' + price + '</span>' : '') +
        '</span>';
      el.addEventListener('mousedown', function (e) { e.preventDefault(); tdaTrack('search', { search_term: lastQuery || input.value.trim(), search_method: 'predictive_select', result_title: p.title, result_type: p.group }); window.location.href = p.url; });
      el.addEventListener('mouseenter', function () { setActive(i); });
      return el;
    }

    function render(q) {
      list.innerHTML = '';
      optEls = [];
      state.hidden = true;
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');

      if (!items.length) {
        showState('No matches, try another term');
        open();
        return;
      }

      // build one element per item, keyed by its flat index (optEls must follow items order)
      var els = items.map(function (p, i) { return makeOpt(p, i, false); });
      var hasProducts = items.some(function (p) { return p.group === 'products'; });
      var hasSide = items.some(function (p) { return p.group !== 'products'; });

      var cols = document.createElement('div');
      cols.className = 'tda-ps__cols';

      function appendGroup(container, key, label, compact, useGrid) {
        var idxs = [];
        items.forEach(function (p, i) { if (p.group === key) idxs.push(i); });
        if (!idxs.length) return;
        container.appendChild(groupHeader(label));
        var holder = container;
        if (useGrid) { holder = document.createElement('div'); holder.className = 'tda-ps__pgrid'; container.appendChild(holder); }
        idxs.forEach(function (i) {
          if (compact) els[i] = makeOpt(items[i], i, true);
          holder.appendChild(els[i]);
        });
      }

      if (hasProducts && hasSide) {
        // Desktop: taxonomy sidebar on the LEFT, products grid on the RIGHT.
        // Each taxonomy group is its own section so mobile can interleave them
        // around the products grid via flex `order` (see the <=760px CSS: the
        // sidebar becomes display:contents and the order is Collections,
        // Products, Pages, Popular Suggestions, Blog posts).
        var side = document.createElement('div');
        side.className = 'tda-ps__side';
        [['collections', 'Collections'], ['pages', 'Pages'], ['suggestions', 'Popular Suggestions'], ['articles', 'Blog posts']].forEach(function (g) {
          if (!items.some(function (p) { return p.group === g[0]; })) return;
          var sec = document.createElement('div');
          sec.className = 'tda-ps__g tda-ps__g--' + g[0];
          appendGroup(sec, g[0], g[1], true, false);
          side.appendChild(sec);
        });
        cols.appendChild(side);

        var main = document.createElement('div');
        main.className = 'tda-ps__main';
        appendGroup(main, 'products', 'Products', false, true);
        cols.appendChild(main);
      } else {
        // single region (only products, or only taxonomy) — fill the width with a grid
        var full = document.createElement('div');
        full.className = 'tda-ps__main tda-ps__main--full';
        GROUPS.forEach(function (g) { appendGroup(full, g.key, g.label, false, true); });
        cols.appendChild(full);
      }

      // optEls in items order so keyboard nav is sequential
      optEls = items.map(function (p, i) { return els[i]; });

      list.appendChild(cols);
      allLink.href = fullHref(q);
      allLink.hidden = false;
      open();
    }

    function mapItem(group, label, o, isProduct) {
      return { group: group, groupLabel: label, title: o.title, url: o.url, image: imgOf(o), price: isProduct ? o.price : null };
    }

    function fetchSuggest(q) {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var sig = controller ? controller.signal : undefined;

      function call(types, limit) {
        var url = SUGGEST + '?q=' + encodeURIComponent(q) +
          '&resources[type]=' + types +
          '&resources[limit]=' + limit +
          '&resources[options][unavailable_products]=last';
        return fetch(url, sig ? { signal: sig } : undefined)
          .then(function (r) { return r.json(); })
          .then(function (d) { return (d && d.resources && d.resources.results) || {}; });
      }

      showState('Searching…');
      open();

      // Separate calls: resources[limit] is a shared total across types, so
      // products need their own call to reach 10 independent of the taxonomy.
      Promise.all([
        call('product', MAX_PRODUCTS),
        call('collection', MAX_COLLECTIONS),
        call('article,page', MAX_EDITORIAL),
        call('query', MAX_SUGGESTIONS)
      ]).then(function (res) {
        if (q !== lastQuery) return; // a newer keystroke won
        var prod = res[0], coll = res[1], ed = res[2], sug = res[3];
        items = [];
        (prod.products || []).slice(0, MAX_PRODUCTS).forEach(function (o) { items.push(mapItem('products', 'Products', o, true)); });
        (coll.collections || []).slice(0, MAX_COLLECTIONS).forEach(function (o) { items.push(mapItem('collections', 'Collections', o, false)); });
        (sug.queries || []).slice(0, MAX_SUGGESTIONS).forEach(function (o) { items.push({ group: 'suggestions', groupLabel: 'Popular Suggestions', title: o.text, url: searchUrl + '?q=' + encodeURIComponent(o.text) + '&type=product', image: '', price: null }); });
        // blog posts + pages share one allotment, blogs first
        var editorial = [];
        (ed.articles || []).forEach(function (o) { editorial.push(mapItem('articles', 'Blog posts', o, false)); });
        (ed.pages || []).forEach(function (o) { editorial.push(mapItem('pages', 'Pages', o, false)); });
        editorial.slice(0, MAX_EDITORIAL).forEach(function (it) { items.push(it); });
        render(q);
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (q !== lastQuery) return;
        showState('Something went wrong, try again');
        open();
      });
    }

    function onInput() {
      var q = input.value.trim();
      lastQuery = q;
      clearBtn.hidden = !input.value;
      if (q.length < minChars) {
        if (timer) clearTimeout(timer);
        if (controller) controller.abort();
        items = [];
        close();
        return;
      }
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { fetchSuggest(q); }, DEBOUNCE_MS);
    }

    input.addEventListener('input', onInput);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        if (!isOpen() && input.value.trim().length >= minChars) { onInput(); return; }
        if (items.length) { e.preventDefault(); setActive((activeIndex + 1) % items.length); }
      } else if (e.key === 'ArrowUp') {
        if (items.length) { e.preventDefault(); setActive((activeIndex - 1 + items.length) % items.length); }
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (activeIndex >= 0 && items[activeIndex]) {
          tdaTrack('search', { search_term: input.value.trim(), search_method: 'predictive_select', result_title: items[activeIndex].title, result_type: items[activeIndex].group }); window.location.href = items[activeIndex].url;
        } else {
          var q = input.value.trim();
          if (q.length >= minChars) { tdaTrack('search', { search_term: q, search_method: 'predictive_submit' }); window.location.href = fullHref(q); }
        }
      } else if (e.key === 'Escape') {
        close();
        input.blur();
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= minChars && items.length) open();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        items = [];
        lastQuery = '';
        close();
        input.focus();
      });
    }

    if (allLink) {
      allLink.addEventListener('mousedown', function (e) {
        e.preventDefault();
        tdaTrack('search', { search_term: input.value.trim() || lastQuery, search_method: 'predictive_viewall' });
        window.location.href = allLink.href;
      });
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });

    input.addEventListener('blur', function () {
      setTimeout(close, 120);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-tda-ps]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
